import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../Reveal";
import { SectionHeading } from "./About";
import { PARTNERS } from "../../lib/siteData";

export const Partners = () => {
  return (
    <section id="partners" data-testid="partners-section" className="bg-secondary py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="Consortium Partners"
            title="Specialist partners, one accountable platform"
            subtitle="Each partner brings deep domain expertise, coordinated under a single client-facing model."
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {PARTNERS.map((p, i) => (
            <Reveal
              key={p.name}
              delay={(i % 3) * 70}
              data-testid={`partner-card-${i}`}
              className={`group flex flex-col justify-between rounded-2xl border border-border bg-white p-7 transition-all hover:border-forest/30 ${
                i === 0 ? "lg:col-span-1 border-forest/20 bg-forest text-white" : ""
              }`}
            >
              <div>
                <div className="flex items-start justify-between">
                  <span
                    className={`font-body text-xs font-semibold uppercase tracking-widest ${
                      i === 0 ? "text-lime-bright" : "text-forest-600"
                    }`}
                  >
                    {p.role}
                  </span>
                  <ArrowUpRight
                    size={18}
                    className={i === 0 ? "text-lime-bright" : "text-muted-foreground"}
                  />
                </div>
                <h3
                  className={`mt-4 font-heading text-lg font-bold leading-snug tracking-tight ${
                    i === 0 ? "text-white" : "text-forest"
                  }`}
                >
                  {p.name}
                </h3>
              </div>
              <p
                className={`mt-4 font-body text-sm leading-relaxed ${
                  i === 0 ? "text-white/70" : "text-muted-foreground"
                }`}
              >
                {p.desc}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
